import { useCallback } from 'react';
import { CardValidationError } from '../../../constants';
import { Psd2AuthData } from '../usePaymentMethodsQuery';
import { useIdentifyShopper } from './useIdentifyShopper';
import { useChallengeShopper } from './useChallengeShopper';
import { useRedirectShopper } from './useRedirectShopper';

export const useVerifyPsd2 = () => {
  const identifyShopper = useIdentifyShopper();
  const challengeShopper = useChallengeShopper();
  const redirectShopper = useRedirectShopper();

  const verifyPsd2 = useCallback(
    (resultCode?: string | null, psd2AuthData?: Psd2AuthData | null) => {
      switch (resultCode) {
        case 'Authorised':
        case null:
        case undefined:
          return Promise.resolve();

        case 'IdentifyShopper':
          return identifyShopper(psd2AuthData);

        case 'ChallengeShopper':
          return challengeShopper(psd2AuthData);

        case 'RedirectShopper':
          return redirectShopper(psd2AuthData);

        default:
          return Promise.reject(new CardValidationError('psd2 verification failed'));
      }
    },
    [identifyShopper, challengeShopper, redirectShopper]
  );

  return verifyPsd2;
};
